<template>

    <div class="conrols-wraper">
        <div class="aligned-controls">
            <SegmentActions v-model="segmentItem" />
            <SegmentStateControls v-model="segmentItem" />
        </div>
        <StateTag v-model="translationSegment" />
    </div>


</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import SegmentActions from './SegmentActions.vue';
    import SegmentStateControls from './SegmentStateControls.vue';
    import StateTag from './StateTag.vue';

    import { SegmentEditorItem } from '@/models/SegmentEditorItem';
    import { TranslationSegment } from '@/models/TranslationSegment';

    export default defineComponent({
        props: {
            modelValue: Object,
        },
        components: {
            SegmentActions,
            SegmentStateControls,
            StateTag,
        },
        data() {
            return {
            }
        },
        computed: {
            segmentItem: {
                get(): SegmentEditorItem { return this.modelValue as SegmentEditorItem; },
                set(value: SegmentEditorItem) { this.$emit('input', value); }
            },
            translationSegment: {
                get(): TranslationSegment { return this.segmentItem.data as TranslationSegment; },
                set(value: TranslationSegment) { this.segmentItem.data = value }
            },
        },
        methods: {
        }

    })

</script>
<style lang="scss" scoped>

    .conrols-wraper {
        display: flex;
        flex-direction: column;

        .aligned-controls {
            display: flex;
            flex-direction: row;
        }
    }
</style>
